import React from "react";
import { useTranslation } from "react-i18next";

import { ClockIcon } from "fe-shared/src/components/Icons";

import { TransactionStatus } from "../../types";

import styles from "./AdjustableStatus.module.scss";

export const AdjustableStatus = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.status}>
      {t(`transactions.statuses.${TransactionStatus.Submitted}`)}
      <ClockIcon width={16} height={16} className={styles.icon} />
    </div>
  );
};

export default AdjustableStatus;
